import { TFunction } from "i18next";

export function unitLabel(title: string | null | undefined, fallback: string) {
  const trimmed = title?.trim();
  return trimmed ? trimmed : fallback;
}

export function addUnitLabel(title: string | null | undefined, t: TFunction) {
  const name = title?.trim();
  return name ? t("Add {{name}}", { name }) : t("Add Location");
}

export function summarizeLabels(labels: string[]) {
  const unique = [...new Set(labels.filter(Boolean))];
  if (unique.length === 0) {
    return "";
  }
  if (unique.length <= 4) {
    return unique.join(", ");
  }
  return `${unique[0]} - ${unique[unique.length - 1]}`;
}

export function applySelectionSubtitle(groups: Array<{ bay: string; times: string[] }>, t: TFunction) {
  const withTimes = groups.filter(group => group.bay && group.times.length > 0);
  if (withTimes.length === 0) {
    return undefined;
  }

  const timeLabels = withTimes.map(group => summarizeLabels(group.times));
  const sameTimes = timeLabels.every(label => label === timeLabels[0]);
  if (sameTimes) {
    const bays = summarizeLabels(withTimes.map(group => group.bay));
    return t("Changes will apply to {{bays}} at {{times}}", { bays, times: timeLabels[0] });
  }

  const parts = withTimes.map((group, index) =>
    t("{{bay}} at {{times}}", { bay: group.bay, times: timeLabels[index] }),
  );
  return `${t("Changes will apply to")} ${parts.join(", ")}`;
}
